import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  templateName = 'base/overview/tests/index';

  redirect(campaign) {
    let { splitTestActions } = campaign;

    if (splitTestActions.length === 1) {
      let testDetailsRoute = 'campaigns.campaign.overview.tests.test';

      if (campaign.isApiTriggered) {
        testDetailsRoute = testDetailsRoute.replace('campaigns.campaign', 'broadcasts.broadcast');
      }

      this.router.transitionTo(testDetailsRoute, splitTestActions[0].get('id'));
    }
  }
}
